import { Controller } from '@hotwired/stimulus';
import { afterTransition } from '../lib/transition';

// Alerte Bootstrap 3 fermable : la fermeture retire `in`
// (fondu CSS `.fade`) puis enlève l'alerte du DOM.
//
// Action attendue : `alert#close` sur le bouton de fermeture.
export default class AlertController extends Controller<HTMLElement> {
  close(): void {
    this.element.classList.remove('in');
    afterTransition(this.element, () => this.element.remove());
  }
}
